module.exports = __webpack_public_path__ + "static/media/glass_furnace.a7a13e4e.jpg";